import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { authApi } from "../apis/authApi";

const initialState = {
  Token: null,
  Flag: null,
  Role: null,
  TrialFlag: false,
  UserData: null,
  isAuthenticated: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.Token = null;
      state.Role = null;
      state.UserData = null;
      state.Flag = null;
      state.TrialFlag = false;
      state.isAuthenticated = false;
    },
    setTrialFlag: (state, { payload }) => {
      state.TrialFlag = payload;
    },
  },  
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.register.matchFulfilled, (state, { payload }) => {
      state.Token = payload.Token;
      state.Role = payload.Role;
      state.UserData = payload.user;
      state.TrialFlag = payload.TrialFlag;
      state.isAuthenticated = true;
    })
    .addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      state.Token = payload.Token;
      state.Role = payload.Role;
      state.UserData = payload.UserData;
      state.Flag = payload.Flag;
      state.TrialFlag = payload.TrialFlag;
      state.isAuthenticated = true;
    })
    .addMatcher(authApi.endpoints.googleLogin.matchFulfilled, (state, { payload }) => {
      state.Token = payload.Token;
      state.Role = payload.Role;
      state.Flag = payload.Flag;
      state.UserData = payload.UserData;
      state.isAuthenticated = true;
      state.TrialFlag = payload.TrialFlag;
    })
    .addMatcher(authApi.endpoints.demoAccess.matchFulfilled, (state, { payload }) => {
      state.Token = payload.Token;
      state.Role = payload.Role;
      state.Flag = payload.Flag;
      state.UserData = payload.UserData;
      state.isAuthenticated = true;
      state.TrialFlag = payload.TrialFlag;
    })
    .addMatcher(authApi.endpoints.refreshToken.matchFulfilled, (state, { payload }) => {
      state.Token = payload.Token;
      state.Role = payload.Role;
      state.UserData = payload.UserData;
      state.Flag = payload.Flag;
      state.TrialFlag = payload.TrialFlag;
      state.isAuthenticated = true;
    })
    .addMatcher(isAnyOf(authApi.endpoints.logout.matchFulfilled, authApi.endpoints.deleteAccount.matchFulfilled, authApi.endpoints.refreshToken.matchRejected), (state) => {
      state.Token = null;
      state.Role = null;
      state.UserData = null;
      state.Flag = null;
      state.TrialFlag = false;
      state.isAuthenticated = false;
    })
    .addMatcher(authApi.endpoints.verifyOTP.matchFulfilled, (state, { payload }) => {
      state.Flag = true;
    })
    .addMatcher(authApi.endpoints.validateSubscriptionStatus.matchFulfilled, (state, { payload }) => {
      state.TrialFlag = false; 
      state.Role = 'Pro_User';
    });
  },
});

export const { logout, setTrialFlag } = authSlice.actions;
export default authSlice.reducer;
